import apiPath from '../constants/apiPath';
// const axios = require('axios')
import axios from 'axios';
import { notifyCartUpdated, openCartDrawer } from './cartDrawerEvents';
import store from '../store';
import { userLogin } from '../actions';
import { internalIpV4 } from './getIp';

// Read the persisted guest/user token from the redux-backed localStorage state.
function readAuthToken() {
    try {
        const u = localStorage.getItem("user");
        return u ? (JSON.parse(u).user?.token || '') : '';
    } catch (e) {
        return '';
    }
}

// Lazily create a guest session so the FIRST api call on a fresh visit (e.g.
// product detail) is never sent without a token. Previously such calls raced
// the Header's guest bootstrap, got a 401, and were turned into a "please login"
// redirect to "/". One shared promise dedupes concurrent first-load requests.
let guestBootstrapPromise = null;
async function ensureGuestToken() {
    const existing = readAuthToken();
    if (existing) return existing;
    if (!guestBootstrapPromise) {
        guestBootstrapPromise = (async () => {
            const data = new FormData();
            data.append("country_id", "91");
            data.append("language", localStorage.getItem("current_lang") || "en");
            data.append("device_type", "Website");
            try { data.append("device_token", await internalIpV4()); } catch (e) { data.append("device_token", ""); }
            const res = await axios({ method: "POST", url: apiPath.baseURL + apiPath.guestUser, data });
            if (res && res.status === 200 && res.data && res.data.data && res.data.data.token) {
                try { store.dispatch(userLogin(res.data.data)); } catch (e) { /* store not ready */ }
                return res.data.data.token;
            }
            return '';
        })().catch(() => '').finally(() => { guestBootstrapPromise = null; });
    }
    return guestBootstrapPromise;
}

async function Http(path, options) {
    try {
        let BaseURL = apiPath.baseURL + path;
        //    console.log(BaseURL);
        let token = readAuthToken();
        let lang = localStorage.getItem("current_lang") ? localStorage.getItem("current_lang") : "en";
        // Fresh visitor with no token yet → establish a guest session first, so
        // the request carries auth (skip for the guest-user bootstrap call itself).
        if (!token && path !== apiPath.guestUser) {
            token = await ensureGuestToken();
        }
        if (token) {
            options.headers = {
                Authorization: `Bearer ${token}`,
                "Accept-Language": lang
            }

        }

        // console.log(options);

        /* let result = await fetch(BaseURL,options)
    .then(res => res.json())
    .then(
      (result) => {
        console.log(result);
      //  return result;
        
      }).catch(err => {
          console.log(err);
      });*/


        options.url = BaseURL
        let result = await axios(options);

        if (
            path === apiPath.AddtoCart &&
            result?.data?.status &&
            typeof window !== 'undefined'
        ) {
            setTimeout(() => notifyCartUpdated(result.data.data || null), 0);

            if (!options.skipCartDrawer && window.location.pathname !== '/cart') {
                setTimeout(openCartDrawer, 0);
            }
        }

        // if(result.status === 401) {
        // localStorage.removeItem("user");
        // window.location.reload();
        // }else if(result.status === 409){
        // localStorage.removeItem("user");
        // window.location.reload();
        // }
        return result;
    } catch (error) {
        if (error.code === "ERR_BAD_REQUEST") {
            let errorss = error.response.status
            if (errorss === 401) {
                localStorage.removeItem("user");
                window.location.href = "/";
            } else if (errorss === 409) {
                localStorage.removeItem("user");
                window.location.href = "/";
            } else if (errorss === 404) {
                let response = {};
                response.statusText = error.message
                response.status = 404;
                return response;
            } else if (errorss === 422) {
                // Validation error (e.g. empty / over-long search query). This is
                // NOT an auth failure — return it to the caller instead of wiping
                // the session and redirecting home.
                let response = {};
                response.statusText = error.response?.data?.message || error.message;
                response.status = 422;
                response.data = error.response?.data;
                return response;
            } else {
                localStorage.removeItem("user");
                window.location.href = "/";
            }
        } 
        else if(error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED') {
          console.log(error.message);
          let response = {};
          response.statusText = null;
          response.status = 400;
          return response;
        }
        else {
            let response = {};
            response.statusText = error.message
            response.status = 504;
            return response;
        }
    }
}
export default Http;
